import { useState, memo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, NavLink } from "react-router-dom";

import authAxios from './authAxios'

import { List } from '@mui/material';
import { ListItemButton } from '@mui/material';
import { ListItemText } from '@mui/material';
import { Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { CircularProgress, Alert } from '@mui/material';

import PortraitSharpIcon from '@mui/icons-material/PortraitSharp';
import AppsSharpIcon from '@mui/icons-material/AppsSharp';
import GroupIcon from '@mui/icons-material/Group';
import InventorySharpIcon from '@mui/icons-material/InventorySharp';
import ShoppingCartSharpIcon from '@mui/icons-material/ShoppingCartSharp';
import QrCodeSharpIcon from '@mui/icons-material/QrCodeSharp';
import ShoppingBagSharpIcon from '@mui/icons-material/ShoppingBagSharp';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';
import SpokeIcon from '@mui/icons-material/Spoke';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SellIcon from '@mui/icons-material/Sell';
import HomeWorkSharpIcon from '@mui/icons-material/HomeWorkSharp';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import BusinessIcon from '@mui/icons-material/Business';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SavingsIcon from '@mui/icons-material/Savings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; // A default icon

import DescriptionIcon from '@mui/icons-material/Description';

import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';


import logo from '../assets/riba-logo.svg'



const ICON_MAP = {
    // Top Level Modules
    DASHBOARD: <AppsSharpIcon className="dashboard-navicon" />,
    PRODUCTS: <InventorySharpIcon className="dashboard-navicon"/>,
    CUSTOMERS: <GroupIcon className="dashboard-navicon" />,
    GUARANTORS: <PortraitSharpIcon className="dashboard-navicon" />,
    ACCOUNTING: <BarChartIcon className="dashboard-navicon" />,
    SETTINGS: <SettingsSharpIcon className="dashboard-navicon" />,
    // Add all other codes and their icons
};

// For fallback, you can use names if needed
const NAME_MAP = {
    Dashboard: <AppsSharpIcon className="dashboard-navicon" />,
    Products: <InventorySharpIcon className="dashboard-navicon"/>,
    Charges: <PlaylistAddIcon className="dashboard-navicon"/>,
    Customers: <GroupIcon className="dashboard-navicon" />,
    Guarantors: <PortraitSharpIcon className="dashboard-navicon" />,
    Applications: <DescriptionIcon className="dashboard-navicon" />,
    Loans: <CreditScoreIcon className="dashboard-navicon" />,
    Accounting: <BarChartIcon className="dashboard-navicon" />,
    Settings: <SettingsSharpIcon className="dashboard-navicon" />,
};

const MenuIcon = ({ code, name }) => {
    // console.log("MenuIcon props:", { code, name });
    // Look up by code first, then by name, then return a default icon.
    // return ICON_MAP[code] || NAME_MAP[name] || <HelpOutlineIcon className="dashboard-navicon" />;
    return ICON_MAP[code] || NAME_MAP[name];
};


const MenuItem = ({ item, openSet, toggle, depth = 0 }) => {
  const hasChildren = item.children && item.children.length > 0;
  const isOpen = openSet.has(item.id);

  return (
    <>
      <ListItemButton
        // className="dashboard-navlink" 
        className={`dashboard-navlink level-${depth}`}
        onClick={() => hasChildren ? toggle(item.id) : null}
        // component={!hasChildren ? Link : "button"}
        component={hasChildren ? "button" : NavLink}
        // component={NavLink}
        to={!hasChildren ? item.path : undefined}
      >
        <MenuIcon code={item.code} name={item.name} />
        <ListItemText primary={item.label || item.name} />

        {hasChildren && (isOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      {hasChildren && (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List 
            component="div" 
            disablePadding
            // className="dashboard-submenu-navlink" 
            className={`dashboard-submenu-navlink level-${depth + 1}`}
        >
            {item.children.map(child => (
              <MenuItem
                key={child.id}
                item={child}
                openSet={openSet}
                toggle={toggle}
                depth={depth + 1}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

const Sidebar = () => {
  const [openSet, setOpenSet] = useState(new Set());

  const { data: userMenu } = useQuery({
    queryKey: ['userMenu'],
    queryFn: () => authAxios.get('/saas/user-menu/').then(res => res.data),
  });

  const toggle = (id) => {
    setOpenSet(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <section className="dashboard-menu flex-column">
      <div className="dashboard-brand">
        <Link to="/"><img src={logo} alt="brand logo" /></Link>
      </div>

      <List>
        {userMenu?.map(item => (
        //   <MenuItem key={item.id} item={item} openSet={openSet} toggle={toggle} />
          <MenuItem key={item.id} item={item} openSet={openSet} toggle={toggle} depth={0} />
        ))}
      </List>
    </section>
  );
};

export default memo(Sidebar);